module.exports = __webpack_public_path__ + "static/img/Jackline2016.8d492a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bssp/Jackline2016.jpg
// module id = 131
// module chunks = 2